<h3 class="forge-typography--heading2">{{title}}</h3>

<div class="sr-only" role="status" aria-live="assertive" aria-atomic="true">
    {{screenReaderAnnouncement}}
</div>

<forge-list cdkDropList (cdkDropListDropped)="onCdkDropListDropped($event)" class="drag-drop-container">
  @for (item of items; track item; let itemIndex = $index) {
    <forge-list-item cdkDrag tabindex="0"
        role="button"
        [attr.data-group-title]="title"
        [attr.data-item-index]="itemIndex"
        [attr.aria-label]="getItemAriaLabel(item, itemIndex)"
        [attr.aria-pressed]="isMoving(itemIndex)"
        [class.keyboard-moving]="isMoving(itemIndex)"
        (keydown)="onItemKeyDown($event, itemIndex)"
        (blur)="onItemBlur($event)">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div class="forge-typography--body2">
                {{getDisplay(item)}}
            </div>
            <forge-icon name="drag_indicator" style="--forge-icon-size: 1rem;"></forge-icon>
        </div>
    </forge-list-item>
  }
</forge-list>
